<!-- src/components/VueForm.vue -->

<template>
    <form class="form" v-on:submit.prevent="$emit('did-submit')">
        <div class="form-elements">
            <slot name="elements">
            </slot>
        </div>
        <div class="form-horizontal-rule"></div>
        <div class="form-footer">
            <slot name="footer"></slot>
        </div>
    </form>
</template>

<script>
export default { 

}
</script>

<style>
.form-elements {
    padding: 0px 20px;
}

.form-footer {
    padding-bottom: 20px;
    text-align: right;
}

.form-elements .half-width label {
    width: 50%;
}

.form-elements .full-width label {
    width: 100%;
}

.form .form-half-field {
    display: flex;
    margin-left: -20px;
    margin-right: -20px;
}

.form .form-half-field label {
    padding-left: 20px;
    padding-right: 20px;
    width: 50%;
}

.form .form-dual-field {
    display: flex;
    align-items: center;
    width: 50%;
}

.form .form-dual-field label {
    width: 50%;
}

.form .form-dual-field label:first-child input {
    border-radius: 5px 0px 0px 5px;
}

.form .form-dual-field label:last-child input {
    border-radius: 0px 5px 5px 0px;
    border-left-width: 0px;
}

.form .form-dual-field label:last-child input:focus {
    margin-left: -1px;
    border-left: 1px solid var(--primary-color1);
}

.form .form-half-field .form-dual-field {
    padding-left: 20px;
    padding-right: 20px;
}

.form .form-half-field .form-dual-field label {
    padding-left: 0px;
    padding-right: 0px;
}

.form .form-horizontal-rule {
    border-bottom: 1px solid #DDD;
    width: 100%;
    height: 0px;
    margin-top: 20px;
    margin-bottom: 20px;
}

.form input,
.form textarea,
.form button {
    width: 100%;
}

.form input[type="checkbox"] {
    width: auto;
}
</style>
